const Skills = () => {
  return (
    <div id="skills" className="p-5">
      <div className="text-center pb-5 mb-10">
        <p className="text-md text-secondary tracking-[2px]">skills</p>
        <p className="text-center text-3xl text-black font-bold">
          <span className="text-primary">MY </span>SKILLS
        </p>
        <p className="text-md text-gray-500 font-semibold">
          HyperText Markup Language serves as the foundation for almost all
          websites
        </p>
      </div>
      <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-10 lg:w-[90%] lg:p-10 bg-white rounded-xl mx-auto">
        <div
          data-aos="fade-right"
          data-aos-easing="linear"
          data-aos-duration="1000"
          className="p-10"
        >
          <h3 className="text-primary font-bold text-3xl">
            <input
              type="radio"
              name="radio-4"
              className="radio radio-primary mr-2"
              checked
            />
            Comfortable
          </h3>

          <div className="mt-5 space-y-4">
            <div className="">
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">HTML, HTML5</h3>
                <span className="text-secondary">90%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="90"
                max="100"
              ></progress>
            </div>
            <div className="">
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">CSS,CSS3</h3>
                <span className="text-secondary">90%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="90"
                max="100"
              ></progress>
            </div>
            <div className="">
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">Css Preprocessor (SASS)</h3>
                <span className="text-secondary">90%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="90"
                max="100"
              ></progress>
            </div>
            <div>
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">Bootstrap, Tailwind css</h3>
                <span className="text-secondary">90%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="90"
                max="100"
              ></progress>
            </div>
            <div>
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">Javascript & Javascript DOM</h3>
                <span className="text-secondary">75%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="75"
                max="100"
              ></progress>
            </div>
            <div>
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">React Js</h3>
                <span className="text-secondary">85%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="85"
                max="100"
              ></progress>
            </div>
            <div>
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">React Router</h3>
                <span className="text-secondary">90%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="90"
                max="100"
              ></progress>
            </div>
            <div>
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">Responsive Design</h3>
                <span className="text-secondary">99%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="99"
                max="100"
              ></progress>
            </div>
          </div>
        </div>
        <div
          data-aos="fade-left"
          data-aos-easing="linear"
          data-aos-duration="1200"
          className="p-10"
        >
          <h3 className="text-primary font-bold text-3xl">
            <input
              type="radio"
              name="radio-4"
              className="radio radio-primary mr-2"
            />
            Basic Skills
          </h3>

          <div className="mt-5 space-y-4">
            <div>
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">Mongo DB</h3>
                <span className="text-secondary">45%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="45"
                max="100"
              ></progress>
            </div>
            <div>
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">Node js(Crud Operation)</h3>
                <span className="text-secondary">45%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="45"
                max="100"
              ></progress>
            </div>
            <div>
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">
                  Express js (Express Router, JWT)
                </h3>
                <span className="text-secondary">40%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="40"
                max="100"
              ></progress>
            </div>
            <div>
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">Firebase authentication</h3>
                <span className="text-secondary">55%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="55"
                max="100"
              ></progress>
            </div>
            <div>
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">Mongoose</h3>
                <span className="text-secondary">60%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="60"
                max="100"
              ></progress>
            </div>
            <div>
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">React Redux (Redux Toolkit)</h3>
                <span className="text-secondary">50%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="50"
                max="100"
              ></progress>
            </div>
            {/* <div>
              <div className="flex justify-between items-center  text-black">
                <h3 className="font-semibold">GraphQl</h3>
                <span className="text-secondary">85%</span>
              </div>
              <progress
                className="progress progress-secondary w-full"
                value="85"
                max="100"
              ></progress>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
